// Where tapping a module goes on mobile: a sub-menu screen for entries with
// children, the Dashboard page for "/" (bare "/" is the mobile Home), and
// the module's own route otherwise.
export function moduleHref(m) {
  if (m.children?.length) return `/?m=menu&to=${encodeURIComponent(m.to)}`;
  if (m.to === "/") return "/?m=dashboard";
  return m.to;
}
